import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { Dispatch, SetStateAction, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { buttonStyle } from './datagrid/ViewLocation';
import { GridCellParams } from '@mui/x-data-grid-pro';

interface DialogModalProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  title?: string;
  contentText: string;
  buttonText?: string;
  param?: GridCellParams;
  doAction: (param?: GridCellParams) => void;
  cancelAction?: () => void;
}

export function DialogConfirmationModal(props: DialogModalProps) {
  const {
    open,
    setOpen,
    title,
    contentText,
    doAction,
    buttonText = 'Delete',
    cancelAction = undefined,
    param = undefined,
  } = props;
  const classes = buttonStyle();
  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {contentText}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={cancelAction || handleClose}>
          {t('actions.cancel')}
        </Button>
        <Button
          classes={{
            root: classes.button,
          }}
          onClick={() => {
            if (param) doAction(param);
            else doAction();
            handleClose();
          }}
          autoFocus
        >
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
